













































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import taskStateColors from "../taskstates";

import {
    transportTaskPlanService
} from "../services";

import {
    TransportTaskDateVehicleEstimate,
    TransportVehicle
} from "../models";

import { CancelToken } from "../cancel";

const MIN_DATE = new Date(new Date().setFullYear(new Date().getFullYear() - 1));

@Component
export default class VehicleCalendar extends Vue {
    @Prop() vehicle!: TransportVehicle;
    @Prop() value!: string;

    taskStateColors = taskStateColors;

    startDate: null | string = null;
    range: null | { start: { date: string, year: number, month: number }, end: { date: string } } = null;

    get title() {
        if (!this.range) {
            return "";
        }

        return this.range.start.year + "-" + this.range.start.month;
    }

    estimates: null | { [date: string]: TransportTaskDateVehicleEstimate } = null;
    estimatesCancel: null | (() => void) = null;

    created() {
    }

    mounted() {
        this.$watch("range", () => { this.loadEstimates(); });
        this.$watch("vehicle", () => { this.loadEstimates(); });

        this.startDate = new Date(new Date(this.value).setDate(1)).toISOString().split("T")[0];
        this.loadEstimates();
    }

    async loadEstimates() {
        if (this.estimatesCancel) {
            this.estimatesCancel();
            this.estimatesCancel = null;
        }

        this.estimates = null;

        if (!this.range) {
            return;
        }

        let startDate = new Date(this.range.start.date);
        const endDate = new Date(this.range.start.date);

        // Calendar range includes only the selected month, but days from neighboring months are displayed on top and bottom row.
        startDate.setDate(startDate.getDate() - 7);
        endDate.setDate(startDate.getDate() + 7);

        if (startDate < MIN_DATE) {
            // Clamp to min date.
            startDate = new Date(MIN_DATE);
        }

        const estimates = await transportTaskPlanService.getTaskDateVehicleEstimates({
            vehicleId: [this.vehicle.vehicleId],
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
        }, new CancelToken(c => { this.estimatesCancel = c; }));

        this.estimatesCancel = null;

        const result: { [date: string]: TransportTaskDateVehicleEstimate } = {};

        for (const estimate of estimates) {
            result[estimate.date.split("T")[0]] = estimate;
        }

        this.estimates = result;
    }

    async updateRange(range: any) {
        this.range = range;
    }

    select(value: { date: string }) {
        const date = new Date(value.date);
        if (date < MIN_DATE) {
            // Prevent selecting older than min date.
            return;
        }

        this.$emit("input", value.date);
    }

    prevMonth() {
        if (this.range && new Date(this.range.start.date) <= MIN_DATE) {
            return;
        }

        (this.$refs.calendar as any).prev();
    }

    nextMonth() {
        (this.$refs.calendar as any).next();
    }
}
